<script>
import UsersListSearch from "../sub-components/UsersListSearch";
import DibbleJS from "../../../dibble";
import DibbleAPI from "../../../api";
import Pagination from "@/commons/pagination/Pagination.vue";
import ModalUserDetails from "@/components/Users/AppUsers/sub-components/ModalUserDetails.vue";
import ModalUserDriverLicense from "@/components/Users/AppUsers/sub-components/ModalUserDriverLicense.vue";
import ModalUserBoatLicense from "@/components/Users/AppUsers/sub-components/ModalUserBoatLicense.vue";
import _ from "lodash";
import {EventBus} from "@/utils/event-bus";
import ModalImportUser from "@/components/Users/AppUsers/sub-components/ModalImportUser.vue";

export default {
    name: "AppUsersList",
    components: {
      ModalImportUser,
        UsersListSearch,
        Pagination,
        ModalUserDetails,
        ModalUserDriverLicense,
        ModalUserBoatLicense
    },
    data() {
        return {
            dibbleJs: DibbleJS,
            usersOrigin: [],
            users: [],
            userRoles: null,
            isShowModalUserForm: false,
            isShowUserDriverLicenseModal: false,
            isShowUserBoatLicenseModal: false,
            isShowImportUserModal: false,
            page: 1,
            total: 0,
            isShowUserDetailsModal: false,
            userId: null,
            searchingText: '',
            isEventBusSearch: false,
        }
    },
    watch: {
        searchingText: _.debounce(function () {
            this.loadUsers();
        }, 300),
    },
    created() {
        this.loadUsers()
        EventBus.$on('searchAppUser', (keywords) => {
          this.isEventBusSearch = true
          this.page = 1
          this.searchingText = keywords
        })
    },
    methods: {
        loadUsers() {
            DibbleJS.showLoader()
            DibbleJS.callApiRequest({
                request: DibbleAPI.api.getAppUsers,
                page: this.page - 1,
                search_string: this.searchingText
            }, (response) => {
                DibbleJS.hideLoader()
                if (DibbleAPI.isResponseSuccess(response)) {
                    if (this.searchingText) {
                      const users = response['users']
                      if (users.length > 0) {
                        if (users.length === 1 && this.isEventBusSearch) {
                          this.userId = users[0].user_id
                          this.showModalUserDetails(this.userId)
                        }

                        this.usersOrigin = this.users = response['users']
                        this.total = response['num_of_pages']
                      } else {
                        DibbleJS.toastErrorMessage('There is no record matched your query.')
                      }

                      if (this.isEventBusSearch) {
                        this.isEventBusSearch = false
                      }
                    } else {
                      this.usersOrigin = this.users = response['users']
                      this.total = response['num_of_pages']
                    }

                } else {
                    DibbleJS.toastErrorMessage(response.message)
                }
            }, this._onRequestFailed)
        },
        showUserModal(mode = 'add') {
            this.$refs.userFormRef.resetModalData()
            if (mode === 'add') {
                this.isShowModalUserForm = true
            }
        },
        editUser(user) {
            this.$emit('setUserData', user)
            this.isShowModalUserForm = true
        },
        modalListenerHandler(eventStr) {
            switch (eventStr) {
                case 'reload':
                    this.isShowModalUserForm = false
                    this.loadUsers()
                    break;
            }
        },
        searchUserHandler(text) {
            if (text === '') {
                this.users = this.usersOrigin
            } else {
                this.users = this.usersOrigin.filter(item =>
                    (item.name.toLowerCase().indexOf(text) > -1)
                    || item.phone.indexOf(text) > -1
                    || item.email.toLowerCase().indexOf(text) > -1
                )
            }
        },
        updateUserStatus(userId, status) {
          DibbleJS.showLoader()
          DibbleJS.callApiRequest({
            request: DibbleAPI.api.setUserActive,
            user_id: userId,
            is_active: !status
          }, (response) => {
            DibbleJS.hideLoader()
            if (DibbleAPI.isResponseSuccess(response)) {
              DibbleJS.toastSuccessMessage(response.message)
              this.loadUsers()
            } else {
              DibbleJS.toastErrorMessage(response.message)
            }
          }, this._onRequestFailed)
        },
        _onRequestFailed(error) {
            DibbleJS.hideLoader();
            console.log(error)
            DibbleJS.toastErrorMessage('Something wrong! can not load data');
        },
        paginationHandle(params) {
            this.page = params.pageIndex
            this.loadUsers()
        },
        showModalUserDetails(userId) {
          this.userId = userId
          this.isShowUserDetailsModal = true
        },
        closeUserDetailsModal() {
          this.isShowUserDetailsModal = false
          this.loadUsers()
        },
        openModalUserDriverLicense() {
          // this.isShowUserDetailsModal = false
          this.isShowUserDriverLicenseModal = true
        },
        openModalUserBoatLicense() {
          // this.isShowUserDetailsModal = false
          this.isShowUserBoatLicenseModal = true
        },
        openImportUserModal() {
          this.isShowImportUserModal = true
        }
    }
}
</script>
<template src="./sub-components/template/users-list.html"></template>
<style lang="scss" scoped>
.payment-page {
    margin: 20px 70px;
    display: flex;
    flex-direction: column;
    user-select: none;
    min-width: 900px;

    p {
        font-family: "Open Sans";
        font-style: normal;
    }

    .title-payment {
        display: flex;
        justify-content: space-between;

        p {
            font-weight: 600;
            font-size: 22px;
            color: #1c5169;
        }
    }

    table {
        width: 100%;
        user-select: none;

        tr {
            user-select: none;
            border-bottom: 1.5px solid #dee6ea;
        }

        th {
            padding-top: 20px;
            padding-bottom: 20px;
            user-select: none;
            font-family: 'Open Sans';
            font-style: normal;
        }

        .title-col {
            font-weight: 600;
            font-size: 20px;
            color: #2C94AB;
        }

        .text-name {
            font-weight: 600;
            font-size: 20px;
            color: #555E67;
        }

        .text-default {
            font-weight: 400;
            font-size: 20px;
            color: #7C7C7A;
        }
    }
}
.user-row {
  cursor: pointer;
  &:hover {
    background: #e8eff1;
  }
}
</style>
